import { DropdownIcon } from 'approot/shared/dropdown/dropdown';
import { DropdownItemDescriptive } from 'approot/shared/dropdown/dropdown-item';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';

const ActivityBuilderZoomToFitControl = ({
  isZoomToFit,
  onClick,
  ...rest
}: {
  isZoomToFit: boolean;
  onClick: (state: boolean) => void;
}) => {
  return (
    <DropdownIcon
      {...rest}
      data-testid="zoom-to-fit-button"
      menuWidth={320}
      buttonElement={
        <ActivityBuilderInlineSvg
          id={isZoomToFit ? 'icon_present' : 'icon_devices'}
          width={20}
          height={20}
        />
      }
      dropdownContents={
        <>
          <DropdownItemDescriptive
            isActive={isZoomToFit}
            icon={
              <ActivityBuilderInlineSvg
                id="icon_present"
                width={24}
                height={24}
              />
            }
            primaryText="Presentation Layout"
            secondaryText="Recommended for desktop or big screens. Layout will be the same in
              print."
            onClick={() => onClick(true)}
            data-testid="zoom-to-fit-button-present"
          />
          <DropdownItemDescriptive
            isActive={!isZoomToFit}
            icon={
              <ActivityBuilderInlineSvg
                id="icon_devices"
                width={24}
                height={24}
              />
            }
            primaryText="Mobile Layout"
            secondaryText="Recommended for tablets and phones. Layout will adapt to your
              screen size."
            onClick={() => onClick(false)}
            data-testid="zoom-to-fit-button-mobile"
          />
        </>
      }
    />
  );
};

export default ActivityBuilderZoomToFitControl;
